/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DeleteProjectConfirmationModal_designProject = {
    readonly serviceId: string | null;
    readonly name: string | null;
    readonly status: string | null;
    readonly " $refType": "DeleteProjectConfirmationModal_designProject";
};
export type DeleteProjectConfirmationModal_designProject$data = DeleteProjectConfirmationModal_designProject;
export type DeleteProjectConfirmationModal_designProject$key = {
    readonly " $data"?: DeleteProjectConfirmationModal_designProject$data;
    readonly " $fragmentRefs": FragmentRefs<"DeleteProjectConfirmationModal_designProject">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "DeleteProjectConfirmationModal_designProject",
  "type": "designProject",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '8f7424f81ae823326929380be1efbe22';
export default node;
